// extracted by mini-css-extract-plugin
module.exports = {"main":"comment_main__3zt49","comment_box":"comment_comment_box__1f-sI"};